import environment from "@app/config/environment";
import { SleepingScientist } from "@lib/demo/SleepingScientist";
import { isDemoEnvironment } from "@lib/demo/isDemoEnvironment";
import { probeApiHealth } from "@lib/demo/probeApiHealth";
import { Anchor, Center, Stack, Text, Title } from "@mantine/core";
import { type ReactNode, useEffect, useState } from "react";

const POLL_MS = 15000;
const DEMO_SLACK_CHANNEL_URL = "https://atinary.slack.com/archives/C0BC86EDSP4";

export function DemoAsleepGate({ children }: { children: ReactNode }) {
  const isDemo = isDemoEnvironment(window.location.hostname);
  const [asleep, setAsleep] = useState(false);

  useEffect(() => {
    if (!isDemo) {
      return;
    }
    let active = true;
    const check = async () => {
      const ok = await probeApiHealth(environment.ATI_API_BASE_URL);
      if (active) {
        setAsleep(!ok);
      }
    };
    void check();
    const id = setInterval(() => void check(), POLL_MS);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, [isDemo]);

  if (isDemo && asleep) {
    return (
      <Center h="100vh" p="xl">
        <Stack align="center" gap="md" maw={460}>
          <SleepingScientist />
          <Title order={2}>This demo is asleep</Title>
          <Text ta="center" c="dimmed">
            Ask in the{" "}
            <Anchor href={DEMO_SLACK_CHANNEL_URL} target="_blank" rel="noreferrer">
              #demo
            </Anchor>{" "}
            Slack channel to wake it: type <b>/demo on</b>. It will be ready in a few minutes and this page will refresh
            on its own.
          </Text>
        </Stack>
      </Center>
    );
  }
  return <>{children}</>;
}
